<template>
  <layout-basic>
    <v-container grid-list-md text-xs-left fluid>
        <v-row class="mb-8">
          <v-col class="Full-Course-Library-Title">
            Reports
          </v-col>
        </v-row>
        <v-layout row wrap>
          
      <v-row v-if="loading">
            <v-flex v-for="index in 4" :key="index" xs12 sm6 lg3 class="mb-5">
              <v-card :class="['card-outter', 'pb-0', { 'mr-6': isTabletOrDesktop }]" height="100%">
                <v-skeleton-loader elevation="2" class="card-loader"
                  type="image, list-item-three-line">
                </v-skeleton-loader>
              </v-card>
            </v-flex>
      </v-row>
        <v-row v-else>
          <v-flex xs12 sm6 md4 lg3 class="report-box" data-tour="report-user">
            <v-hover>
              <v-card
                slot-scope="{ hover }"
                class="text-xs-center px-0 mx-auto"
                height="100%"
                to="/admin/reports/user"
              >
                <v-card-text class="card-box">
                  <img
                    contain
                    :src="$globalConfig.APP_NAME === 'senso' ? '/static/senso-learn-user-reports-icon.png' : '/static/improve-user-reports.png'"
                  />
                </v-card-text>
                <v-card-text>
                  <h2>User Reports</h2>
                  <div class="report-box-short-desc">View your User activity.</div>
                  <v-card-actions>
                    <v-btn
                      color="primary"
                      text
                      class="report-box-action-btn"
                    >
                      SEE REPORT
                    </v-btn>
                  </v-card-actions>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-flex>
          <v-flex xs12 sm6 md4 lg3 class="report-box" data-tour="report-course">
            <v-hover>
              <v-card
                slot-scope="{ hover }"
                class="text-xs-center px-0 mx-auto"
                height="100%"
                to="/admin/reports/course"
              >
                <v-card-text class="card-box">
                  <img
                    contain
                    :src="$globalConfig.APP_NAME === 'senso' ? '/static/senso-learn-course-reports-icon.png' : '/static/improve-course-reports.png'"
                  />
                </v-card-text>
                <v-card-text>
                  <h2>Course Reports</h2>
                  <div class="report-box-short-desc">View Course information & data.</div>
                  <v-card-actions>
                    <v-btn
                      color="primary"
                      text
                      class="report-box-action-btn"
                    >
                      SEE REPORT
                    </v-btn>
                  </v-card-actions>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-flex>
          <v-flex xs12 sm6 md4 lg3 class="report-box" data-tour="report-group">
            <v-hover>
              <v-card
                slot-scope="{ hover }"
                class="text-xs-center px-0 mx-auto"
                height="100%"
                to="/admin/reports/group"
              >
                <v-card-text class="card-box">
                  <img
                    contain
                    :src="$globalConfig.APP_NAME === 'senso' ? '/static/senso-learn-group-reports-icon.png' : '/static/improve-group-reports.png'"
                  />
                </v-card-text>
                <v-card-text>
                  <h2>Group Reports</h2>
                  <div class="report-box-short-desc">View Group activity & data.</div>
                  <v-card-actions>
                    <v-btn
                      color="primary"
                      text
                      class="report-box-action-btn"
                    >
                      SEE REPORT
                    </v-btn>
                  </v-card-actions>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-flex>
          <v-flex xs12 sm6 md4 lg3 class="report-box" data-tour="report-playlist">
            <v-hover>
              <v-card
                slot-scope="{ hover }"
                class="text-xs-center px-0 mx-auto"
                height="100%"
                to="/admin/reports/playlist"
              >
                <v-card-text class="card-box">
                  <img
                    contain
                    :src="$globalConfig.APP_NAME === 'senso' ? '/static/senso-learn-playlist-reports-icon.png' : '/static/improve-playlist-reports.png'"
                  />
                </v-card-text>
                <v-card-text>
                  <h2>Playlist Reports</h2>
                  <div class="report-box-short-desc">View Playlist activity & data.</div>
                  <v-card-actions>
                    <v-btn
                      color="primary"
                      text
                      class="report-box-action-btn"
                    >
                      SEE REPORT
                    </v-btn>
                  </v-card-actions>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-flex>
          <v-flex xs12 sm6 md4 lg3 class="report-box" data-tour="report-external">
            <v-hover>
              <v-card
                slot-scope="{ hover }"
                class="text-xs-center px-0 mx-auto"
                height="100%"
                to="/admin/reports/external-training"
              >
                <v-card-text class="card-box">
                  <img
                    contain
                    :src="$globalConfig.APP_NAME === 'senso' ? '/static/senso-external-training-icon.png' : '/static/improve-external-training.png'"
                  />
                </v-card-text>
               <v-card-text>
                  <h2>External Training</h2>
                  <div class="report-box-short-desc">View & add external training.</div>
                  <v-card-actions>
                    <v-btn
                      color="primary"
                      text
                      class="report-box-action-btn"
                    >
                      SEE REPORT
                    </v-btn>
                  </v-card-actions>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-flex>
          <v-flex xs12 sm6 md4 lg3 class="report-box" data-tour="report-platform">
            <v-hover>
              <v-card
                slot-scope="{ hover }"
                class="text-xs-center px-0 mx-auto"
                height="100%"
              >
                <v-card-text class="card-box">
                  <img
                    contain
                    :src="$globalConfig.APP_NAME === 'senso' ? '/static/learn-full-platform-report-icon.png' : '/static/full-platform-report-icon.png'"
                    style="padding: 10px;"
                  />
                </v-card-text>
               <v-card-text>
                  <h2>Full Platform Report</h2>
                  <div class="report-box-short-desc">Request to download a full platform report.</div>
                  <v-card-actions>
                    <v-btn
                      color="primary"
                      text
                      class="report-box-action-btn"
                      v-on:click="downloadFullPlatformReport"
                    >
                      DOWNLOAD REPORT
                    </v-btn>
                  </v-card-actions>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-flex>
          <v-flex xs12 sm6 md4 lg3 class="report-box">
            <v-hover>
              <v-card
                slot-scope="{ hover }"
                class="text-xs-center px-0 mx-auto"
                height="100%"
              >
                <v-card-text class="card-box">
                  <img
                    contain
                    :src="$globalConfig.APP_NAME === 'senso' ? '/static/learn-full-platform-group-report-icon.png' : '/static/full-platform-group-report-icon.png'"
                    style="padding: 10px;"
                  />
                </v-card-text>
               <v-card-text>
                  <h2>Full Platform Group Report</h2>
                  <div class="report-box-short-desc">Request to download a full platform group report.</div>
                  <v-card-actions>
                    <v-btn
                      color="primary"
                      text
                      class="report-box-action-btn"
                      v-on:click="downloadFullPlatformGroupReport"
                    >
                      DOWNLOAD REPORT
                    </v-btn>
                  </v-card-actions>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-flex>
        </v-row>
      </v-layout>
    </v-container>
  </layout-basic>
</template>
<script>
import LayoutBasic from "@/layouts/Dashboard";
import reportAPI from "@/api/report.js";

export default {
  components: {
    LayoutBasic,
  },
  data() {
    return {
      loading: false,
      successMessage: 'Your request to report will be processed and you will receive an email shortly with the link to the report.'
    };
  },
  mounted() {
  },
  computed: {
  },
  methods: {
    downloadFullPlatformReport(){
      this.loading = true;
      reportAPI.downloadFullPlatformReport().then(() => {
        this.loading = false;
        this.$snotify.success(this.successMessage);
        setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
      });
    },
    downloadFullPlatformGroupReport(){
       this.loading = true;
      reportAPI.exportGroupReport().then(() => {
        this.loading = false;
        this.$snotify.success(this.successMessage);
        setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
      });
    }
  }
};
</script>
<style scoped>

.card-box{
  position: relative;
}
.card-box img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 100%; /* Ensure the image doesn't exceed the container width */
  max-height: 100%; /* Ensure the image doesn't exceed the container height */
}

@media only screen 
  and (min-device-width: 1024px) 
  and (max-device-width: 1366px) 
  and (orientation: landscape) {

    .report-box h2{
      font-size: 17px;
    }
}

@media only screen 
  and (min-device-width: 1366px) 
  and (max-device-width: 1453px) {

    .report-box h2{
      font-size: 16px;
    }
}

@media only screen 
  and (min-device-width: 1264px) 
  and (max-device-width: 1314px){
.report-box h2{
      font-size: 15px;
    }
  }
</style>